import { JSX, useContext, useState, useEffect } from "react";
import { WorkflowContext } from "../../../../context/WorkflowContextProvider";
import { Operator } from "../../../../../../types/entities";
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import {
    useNotify
} from 'react-admin';
import {
    fetchOperatorConnection,
    operatorRequestHeaders,
    OperatorConnection
} from '../../../../../../providers/operatorConnection';

export const OperatorTile: (props: any) => JSX.Element = (props: any): JSX.Element => {
    const operator: any = props.operator;
    const notify: any = useNotify();
    const context: any = useContext(WorkflowContext);
    const [loading, setLoading] = useState<boolean>(true);
    const [isActive, setActive] = useState<boolean>(false);

    function handleOperatorConnection(operator: Operator): void {
        if (isActive) {
            props.setConnectingToOperator(true);
            context.setActiveOperator(operator);
        } else {
            notify('Operator is inactive', { type: 'error' })
        }

    }

    useEffect( (): void => {
        async function loadData(): Promise<void> {
            if (operator.host !== undefined) {
                // HQAPI-76. `operator.token` was the Operator's own standing secret, served on
                // the operators collection. A ticket per tile now, good for about a minute.
                let connection: OperatorConnection;
                try {
                    connection = await fetchOperatorConnection(operator.id);
                } catch (error) {
                    setLoading(false);

                    return;
                }
                let url: string = connection.host + '/system/status';
                const headers: Headers = operatorRequestHeaders(connection);
                headers.set('hq', 'hq');
                const request: Request = new Request(url, {
                    method: "GET",
                    headers: headers,
                });
                try {
                    fetch(request)
                        .then( (response: Response): Promise<any> => {
                            return response.json();
                        })
                        .then( async (data: any): Promise<void> => {
                            if (typeof data['message'] !== "undefined") {
                                let message: string = data['message'];
                                message = JSON.parse(message);
                                if (typeof message !== "undefined" &&
                                    typeof message['response'] !== 'undefined' &&
                                    message['response'] === 'Online'
                                ) {
                                    setActive(true);
                                }
                                setLoading(false);
                            } else {
                                setLoading(false);
                            }

                        })
                        .catch( (error: Error): void => {
                            console.log(error);
                            setLoading(false);
                        })
                } catch (error) {

                }
            }
        }
        loadData();
    }, [operator] );

    if (loading) {
        return (
            <div className="operator__item"
            >
                <HeadsetMicIcon />
                <span >{ "Loading..." }</span>
            </div>
        );
    }

    return (
        <div className="operator__item"
             onClick={ (): void => handleOperatorConnection(operator) }
        >
            { (isActive) &&
                <div className="operator__item__status">
                    <CheckIcon />
                </div>
            }
            { (!isActive) &&
                <div className="operator__item__status error">
                    <CloseIcon />
                </div>
            }
            <HeadsetMicIcon />
            <span >{ operator.name }</span>
        </div>
    );
}